import { createBlock as d, openBlock as r, unref as i, withCtx as l, createElementVNode as a, normalizeStyle as o, renderSlot as s, createVNode as m } from "vue";
import { useTracking as c } from "../../composables/useTracking.js";
/* empty css                     */
import u from "../../atoms/anchor-element/anchor-element.vue.js";
import k from "../../atoms/text-icon-element/text-icon-element.vue.js";
const h = { class: "ds-card-link-with-media__text ds-heading-xsmall" }, y = /* @__PURE__ */ Object.assign({
  name: "DsCardLinkMedia"
}, {
  __name: "card-link-media",
  props: {
    link: {
      type: Object,
      required: !0,
      validator: (t) => ["title", "url", "openInNewWindow", "nuxt"].every((e) => e in t)
    },
    mediaHeight: {
      type: Number,
      default: 264
    }
  },
  setup(t) {
    const { trackingDataProvided: e } = c();
    return (n, w) => (r(), d(i(u), {
      class: "ds-card-link-with-media ds-button-link ds-button-link--chevron ds-button-link--primary ds-button-link--black ds-display-flex",
      style: { "border-radius": "0", width: "100% !important" },
      "tracking-data": { "component-name": n.$options.name, text: t.link.title, ...i(e) },
      url: t.link.url,
      "open-in-new-window": t.link.openInNewWindow,
      nuxt: t.link.nuxt
    }, {
      default: l(() => [
        a("div", {
          class: "ds-card-link-with-media__media ds-width-full",
          style: o([{ width: "100% !important" }, { height: `${t.mediaHeight}px` }])
        }, [
          s(n.$slots, "media")
        ], 4),
        a("h4", h, [
          m(i(k), {
            class: "ds-card-link-with-media__text__link",
            "icon-right": { category: "arrows", name: "chevron-right-small" },
            text: t.link.title
          }, null, 8, ["text"])
        ])
      ]),
      _: 3
    }, 8, ["tracking-data", "url", "open-in-new-window", "nuxt"]));
  }
});
export {
  y as default
};
